import computeClassName from '../../../../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'px-10 xs:px-0 xs:mx-auto xs:w-7/12 pb-6'
});

const propsDefaults = Object.freeze({
  attributeList: [],
  useGridDisplay: true,
});

export default function PartnerProfileOverviewAttributeListSection(
  {
    sectionTitle,
    attributeList = propsDefaults.attributeList,
    useGridDisplay= propsDefaults.useGridDisplay,
    className = ''
  }
) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  return (
    !!attributeList && !!attributeList.length && !!attributeList[0].length &&
    <section className={computedClassName}>
      <h3 className="font-semibold mb-2">{sectionTitle}</h3>
      {
        useGridDisplay ?
          <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 gap-x-6">
            {
              attributeList.map(
                (attributeListItem, index) => {
                  return (<span className="whitespace-nowrap truncate" title={attributeListItem} key={index}>{attributeListItem}</span>)
                }
              )
            }
          </div> :
          <ul className="list-none">
            {
              attributeList.map(
                (attributeListItem, index) => {
                  return (<li key={index}><p className="" title={attributeListItem}>{attributeListItem}</p></li>)
                }
              )
            }
          </ul>
      }
    </section>
  );
}

